// extracted by mini-css-extract-plugin
export default {"title":"CssoP65F9iNen2S4Au5M","tabsList":"_a0rSDm6dtLGSIrirMS7"};